import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getUserAccessStatus } from '../utils';
import { APP_CONFIG } from '../config/app.config';

const FreeRunsIndicator: React.FC = () => {
    const { dbUser } = useAuth();
    const accessStatus = getUserAccessStatus(dbUser);
    
    // Only show for users with free runs
    if (!accessStatus.hasFreeRuns) {
        return null;
    }
    
    const percentage = (accessStatus.freeRunsRemaining / APP_CONFIG.FREE_TRIAL_RUNS) * 100;
    
    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
                <h3 className="text-sm font-medium text-gray-900">Free Meal Plans Remaining</h3>
                <span className="text-2xl font-bold text-green-600">
                    {accessStatus.freeRunsRemaining}
                </span>
            </div>
            
            <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                <div 
                    className="bg-green-600 h-2 rounded-full transition-all duration-300"
                    style={{ width: `${percentage}%` }}
                />
            </div>
            
            <p className="text-xs text-gray-500">
                {accessStatus.freeRunsRemaining === 0 
                    ? "Subscribe to continue creating meal plans"
                    : `You have ${accessStatus.freeRunsRemaining} free meal ${accessStatus.freeRunsRemaining === 1 ? 'plan' : 'plans'} left`}
            </p>
        </div>
    );
};

export default FreeRunsIndicator; 